import { AppLinkTree } from "@megarax/links";

import {
  getAppHomeHref,
  isAppHomeExternal,
  isAppTreeActive,
  isLinkExternal,
  isPageLinkActive,
  linkHref,
} from "./navHelpers";

export type MobileNavShortcut = {
  key: string;
  to: string;
  color: string;
  Icon: AppLinkTree["Icon"];
  isExternal: boolean;
  isActiveAt: (pathname: string, searchParams: URLSearchParams) => boolean;
};

export const toMobileAppShortcuts = (linkTree: AppLinkTree[]): MobileNavShortcut[] =>
  linkTree
    .filter((appTree) => !appTree.hideAppLink)
    .map((appTree) => ({
      key: appTree.app,
      to: getAppHomeHref(appTree),
      color: appTree.color,
      Icon: appTree.Icon,
      isExternal: isAppHomeExternal(appTree),
      isActiveAt: (pathname: string, searchParams: URLSearchParams) =>
        isAppTreeActive(appTree, pathname, searchParams),
    }));

export const toMobileNavShortcuts = (
  linkTree: AppLinkTree[],
  pathname: string,
  searchParams: URLSearchParams,
): MobileNavShortcut[] => {
  const activeApp = linkTree.find((appTree) => isAppTreeActive(appTree, pathname, searchParams));

  if (activeApp && activeApp.pageLinks.length > 0) {
    return activeApp.pageLinks.map((pageLink) => ({
      key: `${activeApp.app}-${pageLink.name}`,
      to: linkHref(pageLink.uri),
      color: activeApp.color,
      Icon: pageLink.Icon,
      isExternal: isLinkExternal(pageLink.uri),
      isActiveAt: (currentPathname: string, currentSearchParams: URLSearchParams) =>
        isPageLinkActive(pageLink, currentPathname, currentSearchParams),
    }));
  }

  return toMobileAppShortcuts(linkTree);
};
